/*
 * @Author: wangkg 
 * @LastEditors: wangkg wangkegui@longfor.com
 * @Description: request 相关方法
 */

import qs from 'qs'

// 获取当前登录后重定向地址
export const getRedirectUrl = () => {
  const {
    search,
    pathname,
    origin
  } = window.location
  // 重定向中不能出现的数据key
  const excludeKey = ['appId', 'token']
  const params = search ? qs.parse(search.substr(1)) : {}
  excludeKey.forEach((key) => {
    if(params[key]) {
      delete params[key]
    }
  })
  let url = `${origin + pathname}?${qs.stringify(params)}`
  // 目前写死，后端较忙
  url = `${origin}/home/index`
  return url
}

export const getUserToken = () => {
  const userToken = localStorage.getItem('userToken')
  return userToken;
}

// 获取应用预览token
export const getAppUserToken = () => {
  const userToken = localStorage.getItem('appUserToken')
  // console.log(userToken)
  return userToken
}

/**
 * @description: 是否包含指定的路径
 * @param {*} arr  当前需要处理的路径list
 * @param {*} url  当前的请求路径
 * @return { Boolean } 
 */
export const isContainPath = (arr, url) => {
  const len = arr.length;
  for(let i = 0; i < len; i++ ) {
    if(url.indexOf(arr[i]) >= 0) {
      return true
    }
  }
  return false
}

/**
 * @description: 预览请求处理
 * @param {*} config 请求默认配置信息
 * @param {*} appBaseURL  应用请求服务
 * @param {*} appRootPath  应用请求相对服务路径
 * @return {String} String
 */
export const  getAppBaseUrl = (config, appBaseURL, appRootPath, isAppPreview) => {
  return
  const { url } = config
  let baseURL = config.baseURL
  // 处理app预览相关接口
  if(appBaseURL) {
    baseURL =  appRootPath ? `${appBaseURL}/${appRootPath}` : appBaseURL
    // 返回网关
    if(isContainPath([
      '/v1/gateway',
      '/oauth2/revoke'
    ], url)) {
      return appBaseURL
    }
    // 返回当前服务
    if(isContainPath([
      'v1/app/gateway/info'
    ], url)) {
      return config.baseURL
    }
  }
  return baseURL
}